// import { FileType } from "../../types/indexTypeEnum";

import { FileType } from "../../types";

interface ReturnValidateFile {
  isValidate: boolean;
  error?: string;
}

/**
 * @description
 * Валидация файла по условиям формата и максимального размера
 * @returns {{isValidate: boolean, error?: string}} Успешна ли валидация и ошибка
 */
export const validateFile = (file: File): ReturnValidateFile => {
  const type = file?.type;
  const fileSizeInMB = file?.size / (1024 * 1024);
  if (!Object.values(FileType).includes(type as FileType)) {
    // eslint-disable-next-line no-console
    return {
      isValidate: false,
      error: `Неверный формат файла`,
    };
  }
  if (fileSizeInMB > 20) {
    // eslint-disable-next-line no-console
    return {
      isValidate: false,
      error: `Размер файла превышает 20 МБ`,
    };
  }
  return {
    isValidate: true,
  };
};
